import { useContext } from 'react';

import { ActiveElementsContext } from './ActiveElementsContext';

export const useActiveElements = () => {
	const context = useContext(ActiveElementsContext);
	if (!context) throw new Error('useActiveElements must be used within ActiveElementsProvider');
	return context;
};
